import { Card, Divider } from "antd";
import composedChart from "./chart";
import rowData from "./rowData";
import { ICourseReportData } from "../../../interfaces/reports-courses.interface";

interface CourseComponent {
  data?: ICourseReportData;
}

const CourseChart = ({ data }: CourseComponent) => {
  return (
    <>
      <div className="flex flex-1 flex-col">
        <Card>
          <div className="flex flex-1 justify-between">
            <div>
              <Divider orientation="left" plain>
                Total students registered by year
              </Divider>
              {composedChart({
                type: "donut",
                key: "courseCode",
                data: data?.studentsByYear ?? [],
                config: {
                  dataKey: "total",
                  legendKey: "paid",
                  label: `Students: ${data?.studentsByYear.reduce((acc: any, item: any) => acc + item.total, 0)}`,
                  legend: ["Code", "Students", "Paid"],
                  colorSet: 1,
                },
              })}
            </div>
            <div>
              <Divider orientation="left" plain>
                Assignments
              </Divider>
              {composedChart({
                type: "pie",
                key: "type",
                data: data?.assignments ?? [],
                config: {
                  dataKey: "total",
                  label: `Assignments: ${data?.assignments?.length}`,
                  colorSet: 3,
                },
              })}
            </div>
          </div>
        </Card>
        <Card className="mt-8">
          <div className="flex-1">
            <Divider orientation="left" plain className="pb-4">
              Total Students by Registration type
            </Divider>
            {composedChart({
              type: "bar",
              key: "registrationType",
              data: data?.totalByRegistrationType ?? [],
              config: {
                xField: "year",
                yField: ["webcastAudit", "webcast", "audit", "inClass"],
                colorSet: 0,
              },
            })}
            {rowData(data?.totalByRegistrationType ?? [], "year", 0)}
          </div>
        </Card>
        <Card className="mt-8">
          <div className="flex-1">
            <Divider orientation="left" plain>
              Students by status
            </Divider>
            {composedChart({
              type: "bar",
              key: "total",
              data: data?.studentsByStatus ?? [],
              config: {
                xField: "date",
                yField: ["fail", "pass", "pending"],
                colorSet: 0,
              },
            })}
            {rowData(data?.studentsByStatus ?? [], "date", 0)}
          </div>
        </Card>
        <Card className="mt-8">
          <div className="flex flex-1 gap-12 justify-between">
            <div className="flex-1">
              <Divider orientation="left" plain>
                Students by payment method
              </Divider>
              {composedChart({
                type: "radar",
                key: "total",
                data: data?.studentsByPayment ?? [],
                config: {
                  xField: "type",
                  yField: "total",
                },
              })}
            </div>
            <div className="flex-1">
              <Divider orientation="left" plain>
                Lectures by Instructor
              </Divider>
              <div className="ml-8">
                {composedChart({
                  type: "verticalBar",
                  key: "registrationType",
                  data: data?.lecturesByInstructor ?? [],
                  config: {
                    xField: "name",
                    yField: "total",
                  },
                })}
              </div>
            </div>
          </div>
        </Card>
      </div>
    </>
  );
};

export default CourseChart;
